module.exports = __webpack_public_path__ + "img/qr-code.d1140d62.svg";